var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useLayoutEffect, useRef, useState, useMemo, } from 'react';
import './main.scss';
import { PrimaryButton } from '../buttons/PrimaryButton';
import closeButton from '../../assets/images/logoListDisplay/clear_all.png';
import Pagination from './Pagination';
import parse from 'html-react-parser';
var BlogListDisplay = function (_a) {
    var partner_data = _a.data.partner_data;
    var _b = useState(1), currentPage = _b[0], setCurrentPage = _b[1];
    var _c = useState(1), previousPage = _c[0], setPreviousPage = _c[1];
    var _d = useState(partner_data), partnerDetails = _d[0], updatePartnerDetails = _d[1];
    var _e = useState(8), patnerDetailsLength = _e[0], updatePartnerDetailsLength = _e[1];
    var _f = useState(false), isPartnerSelected = _f[0], updateIsSelectedPartner = _f[1];
    var blogItemsRef = useRef(null);
    var _g = useState({
        title: '',
        category: [
            {
                id: '',
                label: '',
            },
        ],
        attributes: [
            {
                attribute_type: '',
                attribute_value: '',
            },
        ],
        description: '',
        logo: '',
        search_tags: [
            {
                label: '',
            },
        ],
        cta: [
            {
                url: '',
                title: '',
                is_external: true,
            },
        ],
    }), modalData = _g[0], updateModalData = _g[1];
    var _h = useState([]), filterTagArray = _h[0], setFilterTagArray = _h[1];
    var _j = useState(''), searchValue = _j[0], updateSearchValue = _j[1];
    var _k = useState(true), seeMore = _k[0], setSeeMore = _k[1];
    var _l = useState(true), searchResults = _l[0], setSearchResults = _l[1];
    var _m = useState(0), contentHeight = _m[0], setContentHeight = _m[1];
    var _o = useState(0), containerHeight = _o[0], setContainerHeight = _o[1];
    var _p = useState(null), hoveredItem = _p[0], setHoveredItem = _p[1];
    var filterRef = useRef();
    var filterListTag = [];
    var temp = [];
    var PageSize = window.innerWidth >= 1024
        ? 12
        : window.innerWidth > 600 && window.innerWidth < 1024
            ? 10
            : 8;
    var currentTableData = useMemo(function () {
        // if(previousPage ! == currentPage){
        if (window.innerWidth > 600) {
            var firstPageIndex = (currentPage - 1) * PageSize;
            var lastPageIndex = firstPageIndex + PageSize;
            // console.log(currentPage, searchResults);
            return partnerDetails.slice(firstPageIndex, lastPageIndex);
        }
        else {
            return partnerDetails.slice(0, patnerDetailsLength);
        }
    }, [currentPage, searchResults, partnerDetails, patnerDetailsLength]);
    var addCards = function () {
        updatePartnerDetailsLength(patnerDetailsLength + PageSize);
    };
    var _q = useState(null), hoveredCard = _q[0], setHoveredCard = _q[1];
    var handleCardHover = function (index) {
        setHoveredCard(index);
        var cardsArray = Array.from(document.getElementsByClassName('image-content1'));
        // console.log(index, cardsArray);
    };
    var handleCardLeave = function () {
        setHoveredCard(null);
    };
    var handlePagination = function (page) {
        setCurrentPage(page);
        setTimeout(function () {
            var targetElement = document.getElementById('categoryFilters');
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        }, 10);
    };
    var handleMouseOver = function (i) {
        // console.log(i, 'ok');
        setHoveredItem(i);
    };
    partner_data.map(function (item, index) {
        item.category.map(function (list) {
            if (!temp.includes(list.label) &&
                list.label != '' &&
                list.label != null) {
                temp.push(list.label);
                temp.sort(function (a, b) {
                    return a.toLowerCase().localeCompare(b.toLowerCase());
                });
            }
        });
    });
    temp.forEach(function (value) {
        if (!filterListTag.includes(value)) {
            filterListTag === null || filterListTag === void 0 ? void 0 : filterListTag.push(value);
        }
    });
    useEffect(function () {
        setTimeout(function () {
            var _a, _b;
            var queryString = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search;
            var queryParams = new URLSearchParams(queryString);
            var paramName = 'category';
            var paramValue = queryParams.has(paramName)
                ? queryParams.get(paramName)
                : null;
            if (paramValue !== null) {
                selectedFilter(paramValue.toString());
                var items = Array.from(document.querySelectorAll('.filterItem'));
                var itemTags = Array.from(document.querySelectorAll('.filter-tags'));
                var i = void 0;
                for (i = 0; i < items.length; i++) {
                    if (((_b = itemTags[i]) === null || _b === void 0 ? void 0 : _b.checked) == false &&
                        items[i].innerText.toLowerCase() ==
                            paramValue.toString().toLowerCase()) {
                        itemTags[i].checked = true;
                    }
                }
            }
        }, 100);
    }, []);
    var index = filterListTag.indexOf('Featured');
    if (index > -1) {
        // only splice array if Featured Tag is found
        filterListTag.splice(index, 1);
        filterListTag.unshift('Featured');
    }
    useLayoutEffect(function () {
        var _a, _b;
        if (filterRef && filterRef.current) {
            setContainerHeight((_a = filterRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight);
            setContentHeight((_b = filterRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight);
        }
    }, [filterRef]);
    useEffect(function () {
        function handleWindowResize() {
            var _a, _b;
            if (filterRef && filterRef.current) {
                setContainerHeight((_a = filterRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight);
                setContentHeight((_b = filterRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight);
            }
        }
        window.addEventListener('resize', handleWindowResize);
        return function () {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
    var uncheckAllFilters = function () {
        var _a;
        setSearchResults(true);
        var items = document.querySelectorAll('.filter-tags');
        var i;
        for (i = 0; i < items.length; i++) {
            if (((_a = items[i]) === null || _a === void 0 ? void 0 : _a.checked) == true) {
                items[i].checked = false;
            }
        }
        setFilterTagArray([]);
        updatePartnerDetails(partner_data);
    };
    var selectedFilter = function (item) {
        var _a, _b;
        updateSearchValue('');
        setCurrentPage(1);
        if (filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.includes(item)) {
            filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.splice(filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.indexOf(item), 1);
        }
        else {
            filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.push(item);
        }
        var filterList = [];
        var result;
        partner_data === null || partner_data === void 0 ? void 0 : partner_data.filter(function (items) {
            var _a;
            var filterLabelArray = (_a = items === null || items === void 0 ? void 0 : items.category) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                return item.label;
            });
            result = filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.every(function (item) {
                return filterLabelArray === null || filterLabelArray === void 0 ? void 0 : filterLabelArray.includes(item);
            });
            if (result) {
                filterList === null || filterList === void 0 ? void 0 : filterList.push(items);
            }
        });
        if ((filterList === null || filterList === void 0 ? void 0 : filterList.length) == 0) {
            setSearchResults(false);
        }
        else {
            setSearchResults(true);
        }
        if ((filterTagArray === null || filterTagArray === void 0 ? void 0 : filterTagArray.length) != 0) {
            updatePartnerDetails(filterList);
            (_a = document
                .querySelector('.blogs-list-display-clear-all')) === null || _a === void 0 ? void 0 : _a.classList.add('show');
        }
        else {
            updatePartnerDetails(partner_data);
            (_b = document
                .querySelector('.blogs-list-display-clear-all')) === null || _b === void 0 ? void 0 : _b.classList.remove('show');
        }
    };
    var selectedPartner = function (e, item) {
        updateModalData(__assign(__assign({}, modalData), { title: item === null || item === void 0 ? void 0 : item.title, attributes: item === null || item === void 0 ? void 0 : item.attributes, logo: item === null || item === void 0 ? void 0 : item.logo, cta: item === null || item === void 0 ? void 0 : item.cta, description: item === null || item === void 0 ? void 0 : item.description, category: item === null || item === void 0 ? void 0 : item.category }));
        updateIsSelectedPartner(true);
        document.body.classList.add('no-scroll');
    };
    var closeModal = function () {
        updateIsSelectedPartner(false);
        document.body.classList.remove('no-scroll');
    };
    var seeMoreCount = function () {
        var filterItems = document.querySelector('.filter-list');
        if (seeMore) {
            if (filterItems) {
                filterItems.style.maxHeight = 'max-content';
                filterItems.style.overflow = 'inherit';
            }
        }
        else {
            if (window.innerWidth < 768) {
                if (filterItems) {
                    filterItems.style.maxHeight = '120px';
                    filterItems.style.overflow = 'hidden';
                }
            }
            else {
                if (filterItems) {
                    filterItems.style.maxHeight = '89px';
                    filterItems.style.overflow = 'hidden';
                }
            }
        }
        window.addEventListener('resize', seeMoreCount);
    };
    var renderSeeMore = function () {
        var el = (_jsx("div", __assign({ className: "blogs-list-display-see-more-container" }, { children: _jsx("p", __assign({ className: "see-more", onClick: function () {
                    seeMoreCount();
                    setSeeMore(!seeMore);
                } }, { children: seeMore ? (_jsxs(_Fragment, { children: [_jsx("span", { children: "SEE MORE" }, void 0),
                        _jsx("svg", __assign({ width: "25", height: "12", viewBox: "0 0 11 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M9.942 5.017H6.114V1.009c0-.32-.255-.63-.615-.63-.33 0-.615.28-.615.63v4.008H1.056c-.33 0-.615.279-.615.63 0 .319.255.629.615.629H4.9v3.974c0 .32.255.63.615.63.33 0 .615-.28.615-.63V6.26h3.812c.33 0 .615-.28.615-.63a.623.623 0 0 0-.615-.613z", fill: "#0074BD", stroke: "#0074bd", strokeWidth: ".5" }, void 0) }), void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [_jsx("span", { children: "SEE LESS" }, void 0),
                        _jsx("svg", __assign({ width: "25", height: "25", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M17.059 12.63H8.555", stroke: "#0074bd", strokeWidth: "1.507", strokeLinecap: "square", strokeLinejoin: "round" }, void 0) }), void 0)] }, void 0)) }), void 0) }), void 0));
        if (containerHeight + 3 < contentHeight) {
            return el;
        }
    };
    return (_jsxs("div", __assign({ className: "blogs-list-display-container" }, { children: [_jsxs("div", __assign({ className: "blogs-list-display-category-clear-filter" }, { children: [_jsx("div", __assign({ className: "blogs-list-display-categories-text", id: "categoryFilters" }, { children: "Categories" }), void 0),
                    _jsxs("div", __assign({ className: "blogs-list-display-clear-all", onClick: function () {
                            var _a;
                            uncheckAllFilters();
                            (_a = document
                                .querySelector('.blogs-list-display-clear-all')) === null || _a === void 0 ? void 0 : _a.classList.remove('show');
                        } }, { children: [_jsx("span", { children: "Clear All" }, void 0),
                            _jsx("img", { src: closeButton, alt: "close icon", className: "blogs-list-display-clear-all-close-icon" }, void 0)] }), void 0)] }), void 0),
            _jsx("div", { className: "blogs-list-display-clear-all-divider" }, void 0),
            _jsx("div", __assign({ className: "blogs-list-display-filter-list-container" }, { children: _jsx("ul", __assign({ className: "filter-list", ref: filterRef }, { children: filterListTag === null || filterListTag === void 0 ? void 0 : filterListTag.map(function (item, index) {
                        return (_jsxs("div", { children: [_jsx("input", { className: "filter-tags", type: "checkbox", id: index === null || index === void 0 ? void 0 : index.toString() }, void 0),
                                _jsx("label", __assign({ htmlFor: index === null || index === void 0 ? void 0 : index.toString(), className: "filterItem filterItem-" + index, onClick: function (e) {
                                        selectedFilter(item);
                                    } }, { children: item
                                        .split(' ')
                                        .map(function (item) {
                                        return (item[0].toUpperCase() + item.substring(1, item.length));
                                    })
                                        .join(' ') }), void 0)] }, index));
                    }) }), void 0) }), void 0), renderSeeMore(), !searchResults ? (_jsx("div", __assign({ className: "blogs-list-display-no-result-text" }, { children: _jsx("p", { children: "No Blogs Found" }, void 0) }), void 0)) : (_jsxs("div", { children: [_jsx("div", __assign({ className: "blogs-list-display-section mx-auto" }, { children: _jsx("div", __assign({ className: "blogs-list-display-images ", ref: blogItemsRef }, { children: currentTableData === null || currentTableData === void 0 ? void 0 : currentTableData.map(function (item, index) {
                                return (_jsx("div", __assign({ className: "card-container" }, { children: _jsx("div", __assign({ className: "blogs-list-display-image-container-paginate " + (hoveredCard === index ? 'hovered' : '') + " card", id: "card-" + index }, { children: _jsxs("a", __assign({ href: item === null || item === void 0 ? void 0 : item.url, className: "image-content1 image-content1" + index + " card-front" }, { children: [_jsx("div", { children: _jsx("img", { className: "blogs-list-display-image", src: item === null || item === void 0 ? void 0 : item.image, alt: item === null || item === void 0 ? void 0 : item.title }, void 0) }, void 0),
                                                _jsxs("div", __assign({ className: "main-image-content" }, { children: [_jsx("div", __assign({ className: "image-list-eyebrow" }, { children: item.category.map(function (subItem, index) { return (_jsxs("span", { children: [_jsx("span", __assign({ className: "image-eyebrow" }, { children: subItem.label.toUpperCase() }), void 0), ' ', item.category.length > 1 &&
                                                                        index < item.category.length - 1 && (_jsx("span", { children: "/ " }, void 0))] }, index)); }) }), void 0),
                                                        _jsx("div", __assign({ className: "image-title" }, { children: item.title }), void 0),
                                                        _jsx("div", __assign({ className: "image-description" }, { children: parse(item.description) }), void 0),
                                                        _jsx("div", __assign({ className: "article-sec-cta" }, { children: _jsxs("a", __assign({ href: item.url, className: "flex secondary-sub-cta secondary-button-blue-hover" }, { children: [_jsx("span", __assign({ style: { marginRight: '12px' } }, { children: "Read Article" }), void 0),
                                                                    _jsx("svg", __assign({ width: "15", height: "12", viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M.775 6.38h12.35M9.927 2.033l4.297 4.252-4.297 4.252", stroke: "#005F9E", strokeWidth: "1.5", strokeLinecap: "square", strokeLinejoin: "round" }, void 0) }), void 0)] }), index) }), void 0)] }), void 0),
                                                _jsx("div", __assign({ className: "image-date" }, { children: item.date }), void 0)] }), void 0) }), index) }), index));
                            }) }), void 0) }), void 0),
                    _jsx("div", __assign({ id: "blogs-filter-list" }, { children: (window === null || window === void 0 ? void 0 : window.innerWidth) > 600 && (_jsx(Pagination, { className: "pagination-bar", currentPage: currentPage, totalCount: partnerDetails.length, pageSize: PageSize, onPageChange: function (page) { return handlePagination(page); } }, void 0)) }), void 0),
                    (window === null || window === void 0 ? void 0 : window.innerWidth) <= 600 &&
                        currentTableData.length < partnerDetails.length && (_jsx("div", __assign({ className: " " }, { children: _jsx(PrimaryButton, __assign({ className: " h-[40px]  inner-space1", onClick: addCards }, { children: _jsx("span", __assign({ className: "button-font" }, { children: "View More Articles" }), void 0) }), void 0) }), void 0))] }, void 0))] }), void 0));
};
export default BlogListDisplay;
